export const IImagesRepositoryType = Symbol('IImagesRepository');
